import { render, staticRenderFns } from "./AboutTechProductsBlock.vue?vue&type=template&id=2ca23774"
import script from "./AboutTechProductsBlock.vue?vue&type=script&lang=js"
export * from "./AboutTechProductsBlock.vue?vue&type=script&lang=js"
import style0 from "./AboutTechProductsBlock.vue?vue&type=style&index=0&id=2ca23774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports